import axiosGatweayApi from './axiosGatwayApi';
import { addQueryStringParam } from '../global-functions/addQueryStringParam';
import { cleanUrlParam } from '../global-functions/cleanUrlParam';

class PayloadApi {
    static getPayload(brandId, deviceId, finderTypeId) {
        let requestUrl = '/inkandToner/payload';
        if (brandId) {
            requestUrl += '/' + cleanUrlParam(decodeURIComponent(brandId));

            if (deviceId) {
                requestUrl += '/' + cleanUrlParam(decodeURIComponent(deviceId));
            }
        }
        
        requestUrl += addQueryStringParam("type", finderTypeId);

        return axiosGatweayApi.get(requestUrl).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    }
}

export default PayloadApi;  